import { postalAddress } from "../types";
import api from "./api";

export async function getAdressById(adressId: number): Promise<any | null> {
    return await api
        .get("/api/address/" + adressId)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function putAdressById(
    address: { id: number } & postalAddress
): Promise<any | null> {
    return await api
        .put("/api/address/" + address.id, address)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
